import {
  DELETE_FAVORITE,
  FAVORITES_LOADING,
  GET_FAVORITES,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  PWD_UPDATE_ERROR,
  PWD_UPDATE_SUCCESS,
  REGISTER_SUCCESS,
  UPDATE_FAVORITE,
  USER_CHANGE_LANGUAGE,
  USER_NOTIFICATION,
  USER_PRICING,
  USER_RECORDER,
  USER_SELECTION,
  USER_UPDATE_ERROR,
  USER_UPDATE_SUCCESS,
  USER_UPDATED,
  USER_CHAT_TOKEN,
  USER_HISTORY,
} from "../actions/types";
import i18n from "./../components/helper/i18n";
// import { logout } from "../actions/authActions";

let languageIni = "";
if (localStorage.getItem("language")) {
  try {
    languageIni = JSON.parse(localStorage.getItem("language"));
  } catch (e) {
    console.log("localstorage error", e);
  }
}
let userIni = {};
try {
  userIni = JSON.parse(localStorage.getItem("user"));
} catch (e) {
  console.log("localstorage error", e);
}

let recorder = {};
try {
  recorder = JSON.parse(localStorage.getItem("recorder"));
} catch (e) {
  console.log("localstorage error", e);
}

let historyArrIni = [];
try {
  const savedHistory = localStorage.getItem("historyArr");
  if (savedHistory) {
    historyArrIni = JSON.parse(savedHistory);
  }
} catch (e) {
  console.log("localstorage error for historyArr", e);
}

let selection = {
  projectView: null,
  itemView: null,
  managerTimeRange: null,
  managerSelectedTool: null,
  personalSpaceStats: null,
  personalSpaceSelectedTool: null,
  personalSpaceTimeRange: null,
  personalSpaceFilter: {
    perStatus: null,
    status: null,
  },
  ganttPDF: {
    pdfSize: null,
    pdfOrientation: null,
    pdfShowExport: null,
  },
  itemSelectedTool: null,
  profilSelection: null,
  assignArr: null, //  to be removed
  assignObj: null,
  resourceFilter: null,
  showColor: false,
  // item
};
try {
  let selectionObj = JSON.parse(localStorage.getItem("selection"));
  if (selectionObj !== null) {
    selection = selectionObj;
  }
} catch (e) {
  console.log("localstorage error", e);
}

const initialState = {
  user: userIni,
  favoritesData: [],
  isLoading: false,
  historyArr: historyArrIni,
  pwdUpdateSuccess: "",
  pwdUpdateError: "",
  userUpdateError: "",
  userUpdateSuccess: "",
  emailValidated: true,
  language: languageIni,
  notification: "",
  price: null,
  selection,
  recorder: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        emailValidated: action.payload.emailValidated,
      };

    case USER_CHAT_TOKEN:
      let user1 = state.user;
      user1.chatToken = action.payload;
      return {
        ...state,
        user: user1,
      };

    case USER_RECORDER:
      return {
        ...state,
        recorder: action.payload,
      };

    case USER_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };

    case USER_PRICING:
      return {
        ...state,
        price: action.payload,
      };

    case USER_SELECTION:
      if (action.payload && action.payload !== null) {
        localStorage.setItem("selection", JSON.stringify(action.payload));
      }
      return {
        ...state,
        selection: action.payload,
      };

    case USER_HISTORY:
      if (action.payload && action.payload !== null) {
        localStorage.setItem("historyArr", JSON.stringify(action.payload));
      }
      return {
        ...state,
        historyArr: action.payload,
      };

    case USER_CHANGE_LANGUAGE:
      if (action.payload && action.payload !== null) {
        localStorage.setItem("language", JSON.stringify(action.payload));
      }
      return {
        ...state,
        language: action.payload,
      };

    case USER_UPDATE_ERROR:
      return {
        ...state,
        userUpdateError: action.payload,
      };

    case USER_UPDATE_SUCCESS:
      let lang = state.language;
      if (action.payload.user) {
        localStorage.setItem("user", JSON.stringify(action.payload.user));
        if (action.payload.user.language) {
          lang = action.payload.user.language;
          localStorage.setItem(
            "language",
            JSON.stringify(action.payload.language)
          );
        }
      }
      if (action.payload.user) {
        return {
          ...state,
          user: action.payload.user,
          language: lang,
        };
      } else {
        return { ...state, language: lang };
      }

    case PWD_UPDATE_ERROR:
      return {
        ...state,
        pwdUpdateError: action.payload,
      };

    case PWD_UPDATE_SUCCESS:
      return {
        ...state,
        pwdUpdateSuccess: action.payload,
      };

    case LOGIN_SUCCESS:
      if (action.payload.user)
        localStorage.setItem("user", JSON.stringify(action.payload.user));
      if (action.payload.user.language)
        i18n.changeLanguage(action.payload.user.language);

      if (JSON.stringify(action.payload.user.language)) {
        localStorage.setItem(
          "language",
          JSON.stringify(action.payload.user.language)
        );
      }

      return {
        ...state,
        user: action.payload.user,
        language: action.payload.language,
      };

    case USER_UPDATED:
      if (action.payload)
        localStorage.setItem("user", JSON.stringify(action.payload));
      if (action.payload.language)
        localStorage.setItem(
          "language",
          JSON.stringify(action.payload.language)
        );
      return {
        ...state,
        user: action.payload,
        language: action.payload.language,
      };

    case FAVORITES_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case UPDATE_FAVORITE:
      if (action.payload)
        localStorage.setItem("user", JSON.stringify(action.payload));
      return {
        ...state,
        isLoading: false,
        user: action.payload,
      };

    case GET_FAVORITES:
      return {
        ...state,
        isLoading: false,
        favoritesData: action.payload.favoritesData,
        user: action.payload.user,
      };

    case DELETE_FAVORITE:
      return {
        ...state,
        isLoading: false,
        user: action.payload,
      };

    case LOGOUT_SUCCESS:
      localStorage.removeItem("user");
      return {
        ...state,
        isLoading: false,
        favoritesData: [],
        user: {},
      };

    default:
      return state;
  }
}
